<div class="media-body row">
  <div class="col-md-6 d-flex flex-column justify-content-center">
    <h4 class="media-heading mb-1">{{member.firstname}} {{member.lastname}}
      <small>
        <span class="text-tm">{{member.email}}</span>
        <!-- - {{'added_on' | translate}} {{member.creationDate}} - -->
          <span [hidden]="!member.lastMoodDateMessage"> - {{member.lastMoodDateMessage | translate}}</span>
      </small>
    </h4>
    <div class="text-secondary">
      <div>
        <small>
          <i class="far fa-globe"></i> {{member.notificationTime.timeZone}} - <i class="far fa-clock"></i> {{ renderTime(member.notificationTime.time) }}
        </small>
        <small [hidden]="!!member.emailEnabled">
          - <span class="fa-stack email-disabled-icon">
              <i class="far fa-envelope fa-stack-1x"></i>
              <i class="fal fa-ban fa-stack-2x"></i>
          </span> Email {{ 'disabled' | translate}}
        </small>
        <small [hidden]="!member.slackEnabled">
          - <i class="fab fa-slack"></i> Slack {{ 'enabled' | translate}}
        </small>
        <small [hidden]="!member.msTeamsEnabled">
          - <i class="fab fa-microsoft"></i> Microsoft Teams {{ 'enabled' | translate}}
        </small>
        @if(member.bounced){
            - <span matTooltip="{{member.bounced.date | slice:0:19}} - {{member.bounced.details}}">
                <p class="badge bg-danger">{{ 'email_delivery_failure' | translate }}</p>
            </span>
        }
      </div>

      <div (mouseout)="member.showAllTeams=false">
        <small [hidden]="!(member.teams.length > 1)">
            <i class="fas fa-users"></i> {{ 'member_of' | translate}} {{member.teams.length}} {{ 'teams' | translate}}
            (
              @for(team of member.teams;  track $index; let last = $last){
                @if($index < 3){
                  <span  [ngClass]="{'text-muted': !team.active}" [matTooltip]="team.active? '' : 'user disabled in team'">{{team.name}}{{last ? '' :', '}}</span>
                }
              }
              @if(member.teams.length > 3){
                @if(!member.showAllTeams){
                    <span class="text-link" (mouseover)="member.showAllTeams=true">
                        {{member.teams.length - 3}} {{'polls_settings.show_more' | translate}}
                    </span>
                }@else{
                    <span>
                        @for(team of member.teams; track $index; let last = $last){
                            @if($index >= 3){
                              <span  [ngClass]="{'text-muted': !team.active}" [matTooltip]="team.active? '' : 'user disabled in team'">{{team.name}}{{last ? '' :', '}}</span>
                            }
                        }
                    </span>
                }
              }
            )

        </small>
      </div>
      <div [hidden]="!pausedUntil(member.outOfOffice)">
        <small><i class="fal fa-pause-circle"></i> {{'account_paused' | translate}} {{pausedUntil(member.outOfOffice)?.to}}.</small>
      </div>
    </div>
  </div>

  <div class="col-md-3 d-flex flex-column align-items-start justify-content-center">
    @for (role of member.roles; track role;){
      @switch (role) {
          @case('member'){
              <span class="text-base-role text-member-role"><i class="fa-regular fa-user pe-1"></i>{{ 'teamMember.role_member' | translate }}</span>
          }
          @case('observer'){
            <!-- <span class="text-base-role"><i class="fa-solid fa-eye pe-1"></i>{{ 'teamMember.role_observer' | translate }}</span> -->
            <!-- <span class="text-base-role"><i class="fa-regular fa-book-bookmark pe-1"></i>{{ 'teamMember.role_observer' | translate }}</span> -->
            <span class="text-base-role"><i class="fa-regular fa-tower-cell pe-1"></i>{{ 'teamMember.role_observer' | translate }}</span>
          }
          @case('manager'){
            <small class="text-additionnal-role text-manager-role"><i class="fa-solid fa-users pe-1"></i>{{ 'teamMember.role_manager' | translate }}</small>
          }
          @case('admin'){
            <small class="text-additionnal-role text-admin-role"><i class="fa-solid fa-gears pe-1"></i>{{ 'teamMember.role_admin' | translate }}</small>
          }
          @case('analyst'){
            <small class="text-additionnal-role text-analyst-role"><i class="fa-solid fa-file-chart-column pe-1"></i>{{ 'teamMember.role_analyst' | translate }}</small>
          }
        }
     }
  </div>

  <div class="col-md-3 d-flex justify-content-start align-items-center">
    <span [hidden]="!(member.tags.length > 0)">
      @for(tag of member.tags; track tag.name){
        <span class="badge bg-primary me-1">{{tag.name}}</span>
      }
    </span>
    </div>
</div>
